import React, { useState, useEffect } from "react";
import { loadOrganisations } from "../requests";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { createOrganisation } from "../requests";
import { updateOrganisation } from "../requests";

// const org0 = {
//   name_org: "",
//   department: 0,
//   contact: "",
//   address: "",
//   zipcode: "",
//   city: "",
//   region: "",
//   phonenumber: "",
//   email: "",
//   facebook: "",
//   website: "",
// };

const animatedComponents = makeAnimated();

const GetOrganisation = (props) => {
  const { handleChangeOrganisation } = props;
  const { org } = props;

  const [orgaTri, setOrgaTri] = useState([]);
  const [selectedOrga, setSelectedOrga] = useState(org);

  const handleOrganisation = async (org) => {
    handleChangeOrganisation(org);
    setSelectedOrga(org);
  };

  const handleNewOrganisation = async (e) => {
    const { name, value } = e.target;
    setSelectedOrga((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  // reset organization
  const resetOrg = () => {
    setSelectedOrga({
      name_org: "",
      department: 0,
      contact: "",
      address: "",
      zipcode: "",
      city: "",
      region: "",
      phonenumber: "",
      email: "",
      facebook: "",
      website: "",
    }) && handleOrganisation([]);
  };

  // create new organization
  const sendDataOrg = async () => {
    try {
      selectedOrga["department"] = Number(selectedOrga["department"]);
      delete selectedOrga["__typename"];
      setSelectedOrga(selectedOrga);
      const orgResult = await createOrganisation(selectedOrga, {
        user: "Francis",
      });

      return orgResult;
    } catch (error) {
      console.log(error);
    }
  };
  // update existing organization
  // const updateOrg = async () => {
  //   try {
  //     delete selectedOrga["epreuves"];
  //     delete selectedOrga["__typename"];
  //     alert("obj update org", selectedOrga);

  //     const orgResult = await updateOrganisation(selectedOrga);
  //     return orgResult;
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

const updateOrg = async () => {
  try {
    if (!selectedOrga?.id) {
      throw new Error("Organisation ID manquant");
    }

    const payload = {
      ...selectedOrga,
      department: Number(selectedOrga.department),
    };

    delete payload.__typename;
    delete payload.epreuves;

    const orgResult = await updateOrganisation(payload);
    return orgResult;
  } catch (error) {
    console.error(error);
  }
};




  const fetchDataOrg = async () => {
    try {
      const organisationsResult = await loadOrganisations("");

      setOrgaTri(organisationsResult);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDataOrg();
  }, [orgaTri, selectedOrga, org]);

  return (
    <div className="container">
      <div className="ml-0 mb-2">
        <Select
          onChange={handleOrganisation}
          components={animatedComponents}
          key={`key-org-${selectedOrga.label}`}
          options={orgaTri}
          value={selectedOrga.label}
          placeholder="Tous les clubs"
          getOptionLabel={(options) => options["name_org"]}
          getOptionValue={(options) => options["id"]}
          defaultValue={org}
        />
      </div>
      <div className="">
        {orgKey.map((e, index) => (
          <div className="col-lg-12">
            <span className="row">{orgValue[index]}</span>
            <span className="row">
              <input
                type={
                  orgValue[index] === "id" ||
                  orgValue[index] === "department" ||
                  orgValue[index] === "zipcode"
                    ? "number"
                    : "text"
                }
                key={orgValue[index]}
                name={orgKey[index]}
                className="col-md-12 bg-primary border-0 mr-2 mb-1 w-100 text-decoration-none"
                value={selectedOrga[e] || ""}
                onChange={(e) => handleNewOrganisation(e)}
              />
            </span>
          </div>
        ))}
        <br />
      </div>
      <div className="row">
        <div className="col-md-8">
          <button className="btn btn-danger mr-2" onClick={resetOrg}>
            Effacer
          </button>
        </div>
        <div className="col-md-4">
          {selectedOrga.id ? (
            <button className="btn btn-warning float-right" onClick={updateOrg}>
              Modifier
            </button>
          ) : null}
          {selectedOrga.id ? null : (
            <button
              className="btn btn-primary border border-dark float-right"
              onClick={sendDataOrg}
            >
              Créer
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default GetOrganisation;

const orgKey = [
  "id",
  "name_org",
  "department",
  "contact",
  "address",
  "zipcode",
  "city",
  "region",
  "phonenumber",
  "email",
  "website",
  "facebook",
];

const orgValue = [
  "id",
  "Nom",
  "Département",
  "Contact",
  "Adresse",
  "Code postal",
  "Ville",
  "Région",
  "Téléphone",
  "E-mail",
  "Site web",
  "Facebook",
];

// GetOrganisation.propTypes = {
//   name_org: PropTypes.string.isRequired,
//   department: PropTypes.number.isRequired,
//   contact: PropTypes.string,
//   address: PropTypes.string,
//   zipcode: PropTypes.number,
//   city: PropTypes.string,
//   region: PropTypes.string,
//   phonenumber: PropTypes.string,
//   email: PropTypes.string,
//   website: PropTypes.string,
//   facebook: PropTypes.string,
// };
